(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["callback-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('CallbackDialog');
    if (!dialog) return;
    const model = dialog.querySelector('#CallbackLiftModel');
    document.querySelectorAll('[data-callback-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (model) model.value = trigger.dataset.callbackLift || '';
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-callback-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    if (dialog.querySelector('[data-callback-status]')) dialog.showModal();
  })();
  } catch(e) { console.error(e); }
})();

})();
